import { useClearReportViewOnLeave } from "../useClearReportViewOnLeave";
import { useNavigate } from "react-router-dom";
import { BackBtn } from "../../Users/components/logIncident/logIncident.style";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import { GoPencil } from "react-icons/go";
import type { MenuProps } from "antd";
import { Button } from "antd";
import { FaBell } from "react-icons/fa6";

import styled from "styled-components";
import {
  useAdminWrapper,
  useAnalyticsWrapper,
  useReportWrapper,
  useStoreWrapper,
} from "../../../../store/store";
import { BigBoldText } from "../../dashboard/home/home.style";
import moment from "moment";
import { getTransformedRepeatIncident, triggerMultiExport } from "./formUtils";
import useAnalytics from "../../../../hooks/useAnalytics";
import { useEffect, useRef, useState } from "react";
import { LayerContainer } from "./style";
import { incidentLists, repeatFallCols } from "../dummyData/colums";
import useIncident from "../../../../hooks/useIncident";
import useIncidentTypes from "../../../../hooks/useIncidentTypes";
import { viewClickedIncident } from "../../../../utils/helpers/incidentListUtils";
import ActualVsProjected from "./sections/ActualVsProjected";
import DayOfWeek from "./sections/DayOfWeek";
import ShiftAndUnit from "./sections/ShiftAndUnit";
import PlaceOfIncident from "./sections/PlaceOfIncident";
import ActivityPriorIncident from "./sections/ActivityPriorIncident";
import RepeatFall from "./sections/RepeatFall";
import TimeOfIncident from "./sections/TimeOfIncident";
import { SelectReportType } from "../../../../components/StyledTable/StyledTable.styles";
import CaregiversReporting from "./sections/CaregiversReporting";
import SectionModal from "./sections/SectionModal";
import RestoredDrilldown from "../drilldown/RestoredDrilldown";
import {
  handleCSVDownload,
  handlePDFDownload,
} from "../../../../utils/helpers/pdfCsvUtils";
import FallFilterModal from "./FilterModal";

import EmailSubscriptionForm from "./form/EmailSubForm";

import Modalant from "../../../../components/ModalA/Modalant";
import useSubscriptions from "../../../../hooks/useSubscriptions";
import { toast } from "react-toastify";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { Workbook } from "@progress/kendo-ooxml"; // Import Workbook
import { PDFExport } from "@progress/kendo-react-pdf";

export const HeaderSection = styled.section`
  display: flex;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
export const DateModBtnViewBtnContainer = styled.div``;

export const TitleContainer = styled.div``;
export const ModifyComponent = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const DateDisplayModifyBtnContainer = styled.div`
  border: 1px solid #d9d9d9;
  /* border-radius: 4px 0px 4px 4px; */
`;
export const ModifyBtn = styled.button`
  color: #fff;
  border-left: none;
  border-right: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  /* border-top: none; */
  /* border-bottom: none; */
  background-color: #fff;
  cursor: pointer;
  background-color: var(--main-purple-light);
`;
const ActBtn = styled.button`
  color: #b580ff;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  cursor: pointer;
`;
export const ViewandExportReportBtnContainer = styled.div``;
export const ViewBtnsContainer = styled.div`
  /* width: 100%; */
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const FallAnalysisReport = () => {
  useClearReportViewOnLeave("fall");
  const excelExporter = useRef<ExcelExport>(null);
  const ExportBtn = styled(Button)`
    background-color: var(--main-purple-light) !important;
    border-color: var(--main-purple-light) !important;
    color: #fff !important;
  `;

  const fallAnalysisPDFExportRef = useRef<PDFExport>(null);
  const navigate = useNavigate();

  const [fallAnalysisTableData, setFallAnalysisTableData] = useState<any>([]);
  const [dayOfWeekTableData, setDayOfWeekTableData] = useState<any>([]);
  const [fallsByUnitTableData, setFallsByUnitTableData] = useState<any>([]);
  const [timeOfIncidentTableData, setTimeOfIncidentTableData] = useState<any>(
    []
  );
  const [placeOfIncidentTableData, setPlaceOfIncidentTableData] = useState<any>(
    []
  );
  const [activityPriorTableData, setActivityPriorTableData] = useState<any>([]);
  const [caregiversReportingTableData, setCaregiversReportingTableData] =
    useState<any>([]);
  const [repeatFallTableData, setRepeatFallTableData] = useState<any>([]);
  const [clickedIncident, setClickedIncident] = useState<any>({});
  const [repeatFallData, setRepeatFallData] = useState<any>(null);
  const [incidentListData, setIncidentListData] = useState<any>(null);
  const [additionalAnalyticsData, setAdditionalAnalyticsData] = useState<any>(
    {}
  );
  const [modalData, setModalData] = useState<any>({
    viewModal: false,
    data: null,
    viewType: "",
  });
  const [showFilterModal, setShowFilterModal] = useState<boolean>(false);
  const [showSubscriptionModal, setShowSubscriptionModal] =
    useState<boolean>(false);

  const { createForm, updateForm, user } = useStoreWrapper((state) => ({
    createForm: state.createForm,
    updateForm: state.updateForm,
    user: state.user,
  }));

  const { setIncident } = useReportWrapper((state) => ({
    setIncident: state.setIncident,
  }));

  const { setExpanded } = useAdminWrapper((state) => ({
    setExpanded: state.setExpanded,
  }));

  const { getIncidentDetailsWithId } = useIncident({
    selectedIncidentId: clickedIncident?.incidentId
      ? clickedIncident?.incidentId
      : clickedIncident?.IncidentId,
  });

  const {
    refetch: refetchSelectedIncident,
    isFetching: isFetchingSelectedIncident,
  } = getIncidentDetailsWithId;

  const { incidentTypes: incidentTypesObject } = useIncidentTypes();

  const { handlePostSubscription } = useSubscriptions({});

  const { isLoading: isLoadingSubscription, mutateAsync: doPostSubscription } =
    handlePostSubscription;

  const {
    startDate,
    endDate,
    fallFacility,
    setStartDate,
    setEndDate,
    setFallFacility,
    setGlobalAnaylyticsFacility,
    setGlobalAnalyticsSelectedIncidentType,
    setGlobalAnalyticsSelectedResidentStatus,
  } = useAnalyticsWrapper((state) => ({
    startDate: state.startDate,
    endDate: state.endDate,
    fallFacility: state.fallFacility,
    setStartDate: state.setStartDate,
    setEndDate: state.setEndDate,
    setFallFacility: state.setFallFacility,
    setGlobalAnaylyticsFacility: state.setGlobalAnaylyticsFacility,
    setGlobalAnalyticsSelectedIncidentType:
      state.setGlobalAnalyticsSelectedIncidentType,
    setGlobalAnalyticsSelectedResidentStatus:
      state.setGlobalAnalyticsSelectedResidentStatus,
  }));

  const handleBack = () => {
    setEndDate("");
    setStartDate("");
    setFallFacility(null);
    navigate("/user/analytics");
    setGlobalAnaylyticsFacility(null);
    setGlobalAnalyticsSelectedIncidentType(null);
    setGlobalAnalyticsSelectedResidentStatus([]);
  };

  const {
    getIncidentListAnalysis,
    getRepeatFallAnalysis,
    getOverviewDayOfWeekFallIncidentAnalysis,
    getOverviewOfShiftAndUnitFallIncidents,
    getOverviewTimeOfIncident2HourSpans,
    getFallIncidentPlace,
    getActivityPriorIncient,
    getCaregiversReportingIncidents,
  } = useAnalytics({
    facility: fallFacility?.value || "",
    startDate: moment(startDate).format("yyyy-MM-DD"),
    endDate: moment(endDate).format("yyyy-MM-DD"),
  });

  const {
    data: incidentListAnalysisData,
    isFetching: isFetchingIncidentListAnalysis,
  } = getIncidentListAnalysis;

  const {
    data: repeatFallAnalysisData,
    isFetching: isFetchingRepeatFallAnalysis,
  } = getRepeatFallAnalysis;

  const disableViewBtn =
    isFetchingIncidentListAnalysis || isFetchingRepeatFallAnalysis;

  useEffect(() => {
    if (fallFacility === null || fallFacility === undefined) {
      navigate("/user/analytics");
    }
  }, [fallFacility]);

  useEffect(() => {
    if (repeatFallAnalysisData !== undefined) {
      const _repeatFallAnalysisData = repeatFallAnalysisData?.data.data[0];
      setRepeatFallData(_repeatFallAnalysisData);
    }
  }, [repeatFallAnalysisData]);

  useEffect(() => {
    if (incidentListAnalysisData !== undefined) {
      const _incidentListAnalysisData = incidentListAnalysisData?.data.data[0];
      setIncidentListData(_incidentListAnalysisData);
    }
  }, [incidentListAnalysisData]);

  // add the type of the report to the file name
  const triggerPDFDownload = () => {
    // Use Kendo PDFExport for proper styling matching individual grids
    if (fallAnalysisPDFExportRef.current) {
      fallAnalysisPDFExportRef.current.save();
    }
  };

  useEffect(() => {
    if (
      clickedIncident?.incidentId?.length > 0 ||
      clickedIncident?.IncidentId?.length > 0
    ) {
      const refetchedData = async () => {
        try {
          const response = await refetchSelectedIncident();
          const selectedIncident = response?.data?.data?.data;
          const incidentType = incidentTypesObject.find(
            (incident: any) => incident.flag === selectedIncident.RecordTypeId
          );
          setIncident(selectedIncident);
          viewClickedIncident(
            createForm,
            updateForm,
            selectedIncident,
            incidentType,
            navigate
          );
        } catch (err) {
          console.log({ err });
        }
      };
      refetchedData();
    }
  }, [clickedIncident]);
  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <Button
          onClick={(prev) => setShowSubscriptionModal((prev) => !prev)}
          className="flex w-full items-center border-0"
        >
          <FaBell /> Subscribe
        </Button>
      ),
    },
  ];

  const handleOutsideClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (showFilterModal && !target.closest(".modify-btn-container")) {
      setShowFilterModal(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showFilterModal]);

  interface FormData {
    startDate: string;
    endDate: string;
    startTime: string;
    recurrence: string;
    description: string;
    weeklyDays?: string;
    monthlyDay?: string;
    periodType: string;
    periodLength: string;
  }

  const handleFormSubmit = async (data: FormData) => {
    const subscription = {
      Report_Type__c: "Fall Analytics",
      Incident_Types__c: "Fall",
      Start_Date__c: data.startDate,
      End_Date__c: data.endDate,
      Interval_Type__c: data.recurrence,
      Description__c: data.description,
      User__c: user.userId,
      Facility__c: fallFacility?.value,
      Facilities__c: fallFacility?.value,
      Trailing_Period__c: data.periodType,
      Trailing_Period_Quantity__c: data.periodLength,
      ...(data.recurrence === "weekly" && {
        Day_Of_The_Week__c: data.weeklyDays,
      }),
      ...(data.recurrence === "monthly" && {
        Day_Of_The_Month__c: data.monthlyDay,
      }),
    };

    try {
      const res = await doPostSubscription({ subscription });
      toast.success(res.data.message);
      setShowSubscriptionModal(false);
    } catch (err) {
      console.log({ err });
    }
  };

  const handleExcelExport = () => {
    if (excelExporter.current) {
      const workbook = new Workbook();
      workbook.sheets = [
        {
          name: "Fall Analysis",
          columns: [
            { autoWidth: true },
            { autoWidth: true },
            { autoWidth: true },
            { autoWidth: true },
            { autoWidth: true },
          ],
          rows: [
            {
              cells: [
                {
                  value: "Fall Analysis Report",
                  bold: true,
                  fontSize: 16,
                  textAlign: "center" as const,
                },
                {
                  value: moment(endDate).format("MMM yyyy"),
                  bold: true,
                },
              ],
            },
            {
              cells: [
                { value: "TYPE", bold: true, background: "#f0f0f0" },
                { value: "VALUE", bold: true, background: "#f0f0f0" },
              ],
            },
            ...fallAnalysisTableData.map((row: any) => ({
              cells: [
                { value: row.title, bold: false },
                { value: row.value, bold: false },
              ],
            })),
            {
              cells: [{ value: "" }, { value: "" }],
            },
            {
              cells: [
                {
                  value: "Day of Week Fall Incident Analysis",
                  bold: true,
                  fontSize: 16,
                  textAlign: "center" as const,
                },
                {
                  value: "",
                  bold: true,
                },
              ],
            },
            {
              cells: [
                { value: "DAY", bold: true, background: "#f0f0f0" },
                { value: "COUNT", bold: true, background: "#f0f0f0" },
                { value: "PERCENTAGE", bold: true, background: "#f0f0f0" },
              ],
            },
            ...dayOfWeekTableData.map((row: any) => ({
              cells: [
                { value: row.day, bold: false },
                { value: row.count, bold: false },
                {
                  value: Math.round(row.percentage).toString() + "%",
                  bold: false,
                },
              ],
            })),
            {
              cells: [{ value: "" }, { value: "" }],
            },
            {
              cells: [
                {
                  value: "Falls by Unit",
                  bold: true,
                  fontSize: 16,
                  textAlign: "center" as const,
                },
                {
                  value: "",
                  bold: true,
                },
              ],
            },
            {
              cells: [
                { value: "UNIT", bold: true, background: "#f0f0f0" },
                { value: "11PM-7AM", bold: true, background: "#f0f0f0" },
                { value: "7AM-3PM", bold: true, background: "#f0f0f0" },
                { value: "3PM-11PM", bold: true, background: "#f0f0f0" },
                { value: "TOTAL", bold: true, background: "#f0f0f0" },
              ],
            },
            ...fallsByUnitTableData.map((row: any) => ({
              cells: [
                { value: row.unit, bold: false },
                { value: row["11pm - 7am_count"] ?? 0, bold: false },
                { value: row["7am - 3pm_count"] ?? 0, bold: false },
                { value: row["3pm - 11pm_count"] ?? 0, bold: false },
                { value: row.total_count ?? 0, bold: false },
              ],
            })),
            {
              cells: [{ value: "" }, { value: "" }],
            },
            {
              cells: [
                {
                  value: "Overview of Shift and Fall Time",
                  bold: true,
                  fontSize: 16,
                  textAlign: "center" as const,
                },
                {
                  value: "",
                  bold: true,
                },
              ],
            },
            {
              cells: [
                { value: "MORNING SHIFT", bold: true, background: "#f0f0f0" },
                { value: "NUMBER", bold: true, background: "#f0f0f0" },
                { value: "%", bold: true, background: "#f0f0f0" },
              ],
            },
            ...(timeOfIncidentTableData?.["Morning Shift"] ?? []).map(
              (row: any) => ({
                cells: [
                  { value: row.shift, bold: false },
                  { value: row.count, bold: false },
                  {
                    value: Math.round(row.percentage).toString() + "%",
                    bold: false,
                  },
                ],
              })
            ),
            {
              cells: [{ value: "" }, { value: "" }],
            },
            {
              cells: [
                { value: "AFTERNOON SHIFT", bold: true, background: "#f0f0f0" },
                { value: "NUMBER", bold: true, background: "#f0f0f0" },
                { value: "%", bold: true, background: "#f0f0f0" },
              ],
            },
            ...(timeOfIncidentTableData?.["Afternoon Shift"] ?? []).map(
              (row: any) => ({
                cells: [
                  { value: row.shift, bold: false },
                  { value: row.count, bold: false },
                  {
                    value: Math.round(row.percentage).toString() + "%",
                    bold: false,
                  },
                ],
              })
            ),
            {
              cells: [{ value: "" }, { value: "" }],
            },
            {
              cells: [
                { value: "NIGHT SHIFT", bold: true, background: "#f0f0f0" },
                { value: "NUMBER", bold: true, background: "#f0f0f0" },
                { value: "%", bold: true, background: "#f0f0f0" },
              ],
            },
            ...(timeOfIncidentTableData?.["Night Shift"] ?? []).map(
              (row: any) => ({
                cells: [
                  { value: row.shift, bold: false },
                  { value: row.count, bold: false },
                  {
                    value: Math.round(row.percentage).toString() + "%",
                    bold: false,
                  },
                ],
              })
            ),
            {
              cells: [{ value: "" }, { value: "" }],
            },
            {
              cells: [
                {
                  value: "Place of Incident by Count/Percentage",
                  bold: true,
                  fontSize: 16,
                  textAlign: "center" as const,
                },
                {
                  value: "",
                  bold: true,
                },
              ],
            },
            {
              cells: [
                { value: "PLACE", bold: true, background: "#f0f0f0" },
                { value: "NUMBER", bold: true, background: "#f0f0f0" },
                { value: "%", bold: true, background: "#f0f0f0" },
              ],
            },
            ...placeOfIncidentTableData.map((row: any) => ({
              cells: [
                { value: row.place, bold: false },
                { value: row.count, bold: false },
                {
                  value: Math.round(row.percentage).toString() + "%",
                  bold: false,
                },
              ],
            })),
            {
              cells: [{ value: "" }, { value: "" }],
            },
            {
              cells: [
                {
                  value: "Activity Prior to Incident",
                  bold: true,
                  fontSize: 16,
                  textAlign: "center" as const,
                },
                {
                  value: "",
                  bold: true,
                },
              ],
            },
            {
              cells: [
                { value: "PLACE", bold: true, background: "#f0f0f0" },
                { value: "NUMBER", bold: true, background: "#f0f0f0" },
                { value: "%", bold: true, background: "#f0f0f0" },
              ],
            },
            ...activityPriorTableData.map((row: any) => ({
              cells: [
                { value: row.place, bold: false },
                { value: row.count, bold: false },
                {
                  value: Math.round(row.percentage).toString() + "%",
                  bold: false,
                },
              ],
            })),
            {
              cells: [{ value: "" }, { value: "" }],
            },
            {
              cells: [
                {
                  value: "Caregivers Reporting Multiple Incidents",
                  bold: true,
                  fontSize: 16,
                  textAlign: "center" as const,
                },
                {
                  value: "",
                  bold: true,
                },
              ],
            },
            {
              cells: [
                { value: "RESIDENT", bold: true, background: "#f0f0f0" },
                { value: "NUMBER", bold: true, background: "#f0f0f0" },
                { value: "%", bold: true, background: "#f0f0f0" },
              ],
            },
            ...caregiversReportingTableData.map((row: any) => ({
              cells: [
                { value: row.residentName, bold: false },
                { value: row.count, bold: false },
                {
                  value: Math.round(row.percentage).toString() + "%",
                  bold: false,
                },
              ],
            })),
            {
              cells: [{ value: "" }, { value: "" }],
            },
            {
              cells: [
                {
                  value: "Repeat Fall Incidents",
                  bold: true,
                  fontSize: 16,
                  textAlign: "center" as const,
                },
                {
                  value: "",
                  bold: true,
                },
              ],
            },
            {
              cells: [
                { value: "RESIDENT", bold: true, background: "#f0f0f0" },
                { value: "NUMBER", bold: true, background: "#f0f0f0" },
                { value: "%", bold: true, background: "#f0f0f0" },
              ],
            },
            ...repeatFallTableData.map((row: any) => ({
              cells: [
                { value: row.residentName, bold: false },
                { value: row.count, bold: false },
                {
                  value: Math.round(row.percentage).toString() + "%",
                  bold: false,
                },
              ],
            })),
            {
              cells: [{ value: "" }, { value: "" }],
            },
          ],
        },
      ];

      // Use ExcelExport save method with workbook
      (excelExporter.current as ExcelExport).save(workbook);
    }
  };

  return (
    <div>
      <FlexContainer>
        <BackBtn onClick={() => handleBack()}>
          <ArrowLeftIcon width="30px"></ArrowLeftIcon>
          Back to report categories
        </BackBtn>
      </FlexContainer>
      <HeaderSection className="flex flex-col">
        <TitleContainer className="relative mt-7">
          <BigBoldText
            className="capitalize text-purple-400"
            data-testid="report-title"
          >
            {fallFacility?.label} - Fall Analysis
          </BigBoldText>
        </TitleContainer>

        <DateModBtnViewBtnContainer className="mt-3 flex flex-col justify-between md:flex-row">
          <ModifyComponent className="modify-btn-container w-full md:w-2/5">
            <div className="flex flex-row">
              <DateDisplayModifyBtnContainer className="mb-4 flex h-10 w-full items-center justify-between border-t border-solid border-gray-200 pl-2">
                <p className="text-sm text-purple-400">
                  {moment(startDate).format("LL")} -{" "}
                  {moment(endDate).format("LL")}
                </p>
              </DateDisplayModifyBtnContainer>
              <ModifyBtn
                data-testid="modify-report-params-btn"
                onClick={() => setShowFilterModal((prev) => !prev)}
                className="flex h-10 flex-row items-center justify-between border border-gray-200 px-4 py-2 text-sm"
              >
                <GoPencil className="mr-2" />
                Modify
              </ModifyBtn>
            </div>

            <FallFilterModal
              open={showFilterModal}
              subtitle="Advanced Fall Analysis"
              closeFn={() => setShowFilterModal(false)}
              filterType="advancedFall"
              isModifyMode={showFilterModal}
            />
          </ModifyComponent>
          <ViewandExportReportBtnContainer className="flex h-10 items-end justify-between">
            <ViewBtnsContainer className="mr-2 flex gap-3">
              <ActBtn
                className="text-white h-10 rounded px-4 py-2 text-sm disabled:opacity-50"
                onClick={() =>
                  setModalData({
                    viewModal: true,
                    data: incidentListData,
                    viewType: "incident-list",
                  })
                }
                disabled={disableViewBtn}
              >
                Incident List
              </ActBtn>
              <ActBtn
                className="text-white h-10 rounded px-4 py-2 text-sm disabled:opacity-50"
                onClick={() => {
                  setModalData({
                    viewModal: true,
                    data: getTransformedRepeatIncident([repeatFallData])[0],
                    viewType: "repeat-list",
                  });
                }}
                disabled={disableViewBtn}
              >
                Repeat List
              </ActBtn>
              {/* subscription buttons for desktop */}
              <div className="hidden gap-2 lg:flex">
                {items?.map((item) => (
                  <ActBtn
                    className="text-white h-10 rounded px-4 py-2 text-sm disabled:opacity-50"
                    key={item?.key}
                    // @ts-ignore
                    onClick={item?.label?.props?.onClick}
                  >
                    {/* @ts-ignore */}
                    {item?.label?.props?.children}
                  </ActBtn>
                ))}
              </div>
              <div className="flex gap-2">
                <ExportBtn
                  className="k-button k-button-md k-button-solid k-rounded-md"
                  onClick={handleExcelExport}
                >
                  Export Excel
                </ExportBtn>
              </div>
              <div className="flex gap-2">
                <ExportBtn
                  className="k-button k-button-md k-button-solid k-rounded-md"
                  onClick={triggerPDFDownload}
                >
                  Export PDF
                </ExportBtn>
              </div>
            </ViewBtnsContainer>
          </ViewandExportReportBtnContainer>
        </DateModBtnViewBtnContainer>
      </HeaderSection>
      <PDFExport
        margin="1cm"
        ref={fallAnalysisPDFExportRef}
        fileName={`Fall Analysis Report ${moment(startDate).format("MM-DD-YYYY")} to ${moment(endDate).format("MM-DD-YYYY")}.pdf`}
        paperSize="A3"
        landscape={true}
      >
        <div id="fall-analysis-module" className="relative">
          <div className="relative top-7 mt-7">
            <LayerContainer
              id="actualVsProjected"
              className="pdfExport border-zinc-300 shadow-md"
            >
              <ActualVsProjected
                setClickedIncident={(item: any) => setClickedIncident(item)}
                isFetchingSelectedIncident={isFetchingSelectedIncident}
                shareTableData={(data: any) => setFallAnalysisTableData(data)}
              />
            </LayerContainer>
            <LayerContainer
              id="dayOfWeek"
              className="pdfExport border-zinc-300 shadow-md"
            >
              <DayOfWeek
                setClickedIncident={(item: any) => setClickedIncident(item)}
                isFetchingSelectedIncident={isFetchingSelectedIncident}
                shareTableData={(data: any) => setDayOfWeekTableData(data)}
              />
            </LayerContainer>
            <LayerContainer
              id="shiftAndUnit"
              className="pdfExport border-zinc-300 shadow-md"
            >
              <ShiftAndUnit
                setClickedIncident={(item: any) => setClickedIncident(item)}
                isFetchingSelectedIncident={isFetchingSelectedIncident}
                shareTableData={(data: any) => setFallsByUnitTableData(data)}
              />
            </LayerContainer>
            <LayerContainer
              id="timeOfIncident"
              className="pdfExport border-zinc-300 shadow-md"
            >
              <TimeOfIncident
                setClickedIncident={(item: any) => setClickedIncident(item)}
                isFetchingSelectedIncident={isFetchingSelectedIncident}
                shareTableData={(data: any) => setTimeOfIncidentTableData(data)}
              />
            </LayerContainer>
            <LayerContainer
              id="placeOfIncident"
              className="pdfExport border-zinc-300 shadow-md"
            >
              <PlaceOfIncident
                setClickedIncident={(item: any) => setClickedIncident(item)}
                isFetchingSelectedIncident={isFetchingSelectedIncident}
                shareTableData={(data: any) =>
                  setPlaceOfIncidentTableData(data)
                }
              />
            </LayerContainer>
            <LayerContainer
              id="activityPrior"
              className="pdfExport border-zinc-300 shadow-md"
            >
              <ActivityPriorIncident
                setClickedIncident={(item: any) => setClickedIncident(item)}
                isFetchingSelectedIncident={isFetchingSelectedIncident}
                shareTableData={(data: any) => setActivityPriorTableData(data)}
              />
            </LayerContainer>
            <LayerContainer
              id="caregiversReporting"
              className="pdfExport border-zinc-300 shadow-md"
            >
              <CaregiversReporting
                setClickedIncident={(item: any) => setClickedIncident(item)}
                isFetchingSelectedIncident={isFetchingSelectedIncident}
                shareTableData={(data: any) =>
                  setCaregiversReportingTableData(data)
                }
              />
            </LayerContainer>
            <LayerContainer
              id="repeatFall"
              className="pdfExport border-zinc-300 shadow-md"
            >
              <RepeatFall
                setClickedIncident={(item: any) => setClickedIncident(item)}
                isFetchingSelectedIncident={isFetchingSelectedIncident}
                shareTableData={(data: any) => setRepeatFallTableData(data)}
              />
            </LayerContainer>
          </div>
        </div>
      </PDFExport>
      <RestoredDrilldown report="fall" Modal={SectionModal} />
      {modalData.viewModal ? (
        <SectionModal
          open={modalData.viewModal}
          facilityName={fallFacility?.label}
          startDate={startDate}
          endDate={endDate}
          closeFn={() =>
            setModalData({ viewModal: false, data: null, viewType: "" })
          }
          resetFn={() =>
            setModalData({ viewModal: false, data: null, viewType: "" })
          }
          isLoading={isFetchingSelectedIncident}
          tableData={
            modalData?.data?.incidents || modalData?.data?.Incidents || []
          }
          tableCols={
            modalData.viewType === "repeat-list"
              ? repeatFallCols(true)
              : incidentLists()
          }
          title={`${modalData.viewType === "repeat-list" ? "Repeat List" : "Incident List"}`}
          getUserCallback={(item: any) => {
            if (modalData?.viewType === "incident-list") {
              setClickedIncident(item);
            } else return;
          }}
          handlePdfExport={() =>
            handlePDFDownload({
              data:
                modalData?.data?.incidents || modalData?.data?.Incidents || [],
              columnData:
                modalData.viewType === "repeat-list"
                  ? repeatFallCols(true)
                  : incidentLists(),
              fileName: fallFacility?.label,
              startDate,
              endDate,
              subTitle: `${modalData.viewType === "repeat-list" ? "Repeat List" : "Incident List"}`,
            })
          }
          handleCsvExport={() =>
            handleCSVDownload(
              modalData?.data?.incidents || modalData?.data?.Incidents || [],
              modalData.viewType === "repeat-list"
                ? repeatFallCols()
                : incidentLists(),
              fallFacility?.label
            )
          }
        />
      ) : null}

      {showSubscriptionModal && (
        <Modalant
          isLoading={isLoadingSubscription}
          className="items-center md:w-6/12"
          isOpen={showSubscriptionModal}
          isClose={() => setShowSubscriptionModal(false)}
        >
          <EmailSubscriptionForm
            handleSubmit={handleFormSubmit}
            handleClose={() => setShowSubscriptionModal(false)}
            isFacility={true}
            isLoading={isLoadingSubscription}
            title={"Fall Analysis"}
          />
        </Modalant>
      )}
      <ExcelExport ref={excelExporter} data={[]} />
    </div>
  );
};

export default FallAnalysisReport;
